"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpectatorRoomSession = void 0;
const create_room_status_observable_1 = require("../../util/create_room_status_observable");
const validate_config_shape_1 = require("../../util/validate_config_shape");
const ar_controller_1 = require("../controllers/ar_controller");
const room_session_1 = require("./room_session");
const streem_sdk_protobuf_1 = require("streem-sdk-protobuf");
class SpectatorRoomSession extends room_session_1.RoomSession {
    static initialize(config) {
        const _super = Object.create(null, {
            buildWallSyncClient: { get: () => super.buildWallSyncClient }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return new SpectatorRoomSession(config, yield _super.buildWallSyncClient.call(this, config));
        });
    }
    constructor(config, wallSyncClient) {
        super(config, wallSyncClient);
        this.config = config;
        (0, validate_config_shape_1.validateConfigShape)(['onEnd', 'localUserId', 'localDeviceId', 'remoteUserId', 'remoteDeviceId', 'roomId'], config);
        this.ar = new ar_controller_1.ARController(Object.assign(Object.assign({}, this.controllerConfig), { mediaController: this.media, deleteLocalItemsOnRemoteCameraSubjectChange: true }));
        this.status = (0, create_room_status_observable_1.createRoomStatusObservable)(this.room.roomStatus, this.room.localParticipantStatus, this.room.remoteParticipantStatus, this.invitationController.incomingInvitationStatus);
    }
    connectToRoom() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.connect();
            yield this.media.createSpectatorTracks();
            yield this.media.connect(this.config.roomId, this.config.localUserId);
        });
    }
}
exports.SpectatorRoomSession = SpectatorRoomSession;
SpectatorRoomSession.canSendCameraSubjects = [
    streem_sdk_protobuf_1.CameraSubject.CAMERA_SUBJECT_PERSON,
];
//# sourceMappingURL=spectator_room_session.js.map